import React, { createContext, useEffect, useMemo, useState } from 'react'
import { PATH_T_KATEGORI_DETAILS } from '../consts/RouterPaths';


// export const pageDefaults = [{name:'Trendyol En Yeni İndirimler',to:'/tdetails'},{name:'Hepsiburada En Yeni İndirimler',to:'/hdetails'},{name:'Amazon En Yeni İndirimler',to:'/adetails'}];
export const pageDefaults = [
    {
        name:'Elektronik',
        to:'/kategori/Elektronik'
    },
    {
        name:'Moda',
        to:'/kategori/Moda'
    },
    {
        name:'Anne, Bebek ve Oyuncak',
        to:'/kategori/Anne, Bebek ve Oyuncak'
    },
    {
        name:'Ev ve Yaşam',
        to:'/kategori/Ev ve Yaşam'
    },
    {
        name:'Kırtasiye ve Ofis',
        to:'/kategori/Kırtasiye ve Ofis'
    },
    {
        name:'Süpermarket',
        to:'/kategori/Süpermarket'
    },
    {
        name:'Kozmetik',
        to:'/kategori/Kozmetik'
    },
    {
        name:'Yapı Market ve Otomotiv',
        to:'/kategori/Yapı Market ve Otomotiv'
    },
    {
        name:'Spor ve Outdoor',
        to:'/kategori/Spor ve Outdoor'
    }
];

export const menuSettingDefaults = ['Giriş Yap'];


// Bu default değerleri vermezsen build olmuyor
export const MenuContext = createContext({
    pages: pageDefaults,
    setPages: () => {},
    menuSettings: menuSettingDefaults,
    setMenuSettings: () => {}
});

const MenuContextProvider = ({ children }) => {
    const [pages, setPages] = useState(pageDefaults);
    const [menuSettings, setMenuSettings] = useState(menuSettingDefaults);
    const value = useMemo(() => ({ pages, setPages,menuSettings,setMenuSettings}), [pages,menuSettings]);


    useEffect(()=>{
        debugger;
    },[])


    return (
        <MenuContext.Provider value={value}>
            {children}
        </MenuContext.Provider>
    )
}

export default MenuContextProvider;
